import { render, staticRenderFns } from "./PatientFormModal.vue?vue&type=template&id=666c8c6e&"
import script from "./PatientFormModal.vue?vue&type=script&lang=js&"
export * from "./PatientFormModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientFormModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports